import { render, staticRenderFns } from "./MonthlyRecommended.vue?vue&type=template&id=5d1e7b72&"
import script from "./MonthlyRecommended.vue?vue&type=script&lang=js&"
export * from "./MonthlyRecommended.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyRecommended.vue?vue&type=style&index=0&id=5d1e7b72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports